import StatusChip from '~/components/core/StatusChip';

export const STATUS_TO_CHIP: Record<string, string> = {
  pending: StatusChip.STATUSES.PENDING,
  in_progress: StatusChip.STATUSES.IN_PROGRESS,
  completed: StatusChip.STATUSES.SUCCESS,
  completed_with_errors: StatusChip.STATUSES.ERROR,
};
